function getRuntime() {
    if (typeof window !== 'undefined' && window.__APP_CONFIG__) {
        return window.__APP_CONFIG__;
    }
    return {};
}

export async function getConfig() {
    const runtime = getRuntime();

    if (!runtime.RDARR_APP_URL) {
        const response = await fetch('/api/features/config'); // This will hit the ERM Portal API, because the base path is the same as the hosting page.
        const data = await response.json();
        const config = { ...runtime, ...data };

        window.__APP_CONFIG__ = config;
        return config;
    }

    return runtime;
}
